<template>
  <div id="app">
    <malden-simple-header></malden-simple-header>
    <malden-we-are-logo></malden-we-are-logo>
    <router-view></router-view>
    <malden-footer></malden-footer>
  </div>
</template>

<script>
import maldenSimpleHeader from "@/components/Malden-Simple-Header";
import maldenWeAreLogo from "@/components/Malden-We-Are-Logo";
import maldenFooter from "@/components/Malden-Footer";

export default {
  name: "app",
  components: {
    maldenFooter,
    maldenSimpleHeader,
    maldenWeAreLogo
  }
};
</script>
